import { useRefreshShell } from '@/context/shell-context';
import { useDonorConnect } from '@hooks/register/use-donor-connect';
import type { TLocalize } from '@hooks/use-localize';

interface IDonorMentorModalProps {
    t: TLocalize;
    registrationId: number;
    editKey: string;
    connectToDonorStatus: number | null;
    onClose: () => void;
}

const DonorMentorModal = ({ t, registrationId, editKey, connectToDonorStatus, onClose }: IDonorMentorModalProps) => {
    const { submit, isSubmitting, submitError } = useDonorConnect(registrationId, editKey);
    const refreshShell = useRefreshShell();

    const onConnect = async () => {
        const result = await submit(true);

        if (result.ok) {
            refreshShell();
        }
    };

    return (
        <div id="donorMentorModal" className="modal fade in" role="dialog" style={{ display: 'block' }}>
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" aria-label="Close" onClick={onClose}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 className="modal-title">
                            {t('DashLabel_LivingDonorMentor', 'Living Donor Mentor')}
                        </h4>
                    </div>
                    {connectToDonorStatus == null ?
                        <div className="modal-body">
                            <p>
                                {t(
                                    'DashLabel_LivingDonorMentorIntro',
                                    'Your decision to explore living donation is an incredibly generous one. To support you throughout the process, the NKR offers access to living donor mentors — individuals who have personally gone through the donation journey. They can share their experiences, answer questions, provide reassurance, and help you better understand what to expect along the way.',
                                )}
                            </p>
                            <p>
                                <strong>
                                    {t(
                                        'DashLabel_LivingDonorMentorQuestion',
                                        'Would you like to be connected with a living donor mentor?',
                                    )}
                                </strong>
                            </p>
                            {submitError && <div className="alert alert-danger">{submitError}</div>}
                        </div>
                        :
                        <div className="modal-body">
                            <p>
                                {t(
                                    'DashLabel_ThankYou',
                                    'Thank You',
                                )}
                            </p>

                            <p>
                                {t(
                                    'DashLabel_WeHaveReceivedYourRequestConnect ',
                                    'We have received your request for a donor mentor; we will work to connect you with a donor mentor as soon as possible',
                                )}
                            </p>
                            {submitError && <div className="alert alert-danger">{submitError}</div>}
                        </div>
                    }

                    <div className="modal-footer">
                        {connectToDonorStatus == null ?
                            <div className="row">
                                <div className="col-xs-12 col-sm-8 xsonly-padtop">
                                    <button
                                        type="button"
                                        className="btn btn-nkr-red col-xs-12"
                                        disabled={isSubmitting}
                                        onClick={() => void onConnect()}
                                    >
                                        {t(
                                            'DashLabel_ConnectMeWithALivingDonor',
                                            'Connect Me With a Living Donor',
                                        )}
                                    </button>
                                </div>
                                <div className="col-xs-12 col-sm-3 col-sm-offset-1">
                                    <button
                                        type="button"
                                        className="btn btn-default col-xs-12"
                                        disabled={isSubmitting}
                                        onClick={onClose}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                            :
                            <div className="col-xs-12 col-sm-3 pull-right">
                                <button
                                    type="button"
                                    className="btn btn-default col-xs-12"
                                    disabled={isSubmitting}
                                    onClick={onClose}
                                >
                                    Close
                                </button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DonorMentorModal;
